import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Question from './Question';
import { isKioskMode } from 'checkout/selectors/ui';
import Translation from "../../../../shared/Translation";

class EventQuestionList extends Component {
    render() {
        if(this.props.isKioskMode){
            return(
                <div className="kiosk__checkout__questions">
                    {this.getEventQuestions()}
                    {this.getTicketQuestions()}
                </div>
            )
        }
        return (
            <div className={this.props.numEvents > 1 ? "event-questions form-card" : ""}>
                {this.props.numEvents > 1 && <div className="event-questions__header form-card__header">
                    <h4 className="event-questions__event-name" dangerouslySetInnerHTML={{__html: this.props.eventTitle}}>
                        {/* <br> {formatted_date} @ {resource.venue.name} */}
                    </h4>
                </div>}
                <div className={this.props.numEvents > 1 ? "event-questions__body form-card__content" : ""}>
                    <div className="question">
                        {this.getEventQuestions()}
                        {this.getTicketQuestions()}
                    </div>
                </div>
            </div>
        )
    }

    getEventQuestions = () => {
        return this.props.questions.map((q, i) => {
            return <Question question={q} key={i}/>
        });
    }

    getTicketQuestions = () => {
        let ticketNum = 0;
        let tickets = [];
        for (const id in this.props.ticketQuestions) {
            ticketNum++;
            tickets = tickets.concat(this.renderTicketQuestions(id, ticketNum));
        }

        return tickets;
    }

    renderTicketQuestions = (id, ticketNum) => {
        return this.props.ticketQuestions[id].map((q, i) => {
            return <div className="ticket-question" key={ticketNum + '_' + i}>
                <div className="ticket-questions__header">
                    <h5 className="ticket-questions__ticket-name">
                        <Translation interpolation={{ticketNumber:ticketNum, ticketName:this.getResourceNameFromQuestion(q)}}>{'checkout__ticket_number'}</Translation>
                    </h5>
                </div>
                <div className={this.props.numEvents > 1 ? "ticket-questions__body" : ""}>
                    <div className="question input">
                        <Question question={q}/>
                    </div>
                </div>
            </div>
        });
    }

    //get description of bundle or ticket to display with question
    getResourceNameFromQuestion = (question) => {
        let resourceName = null;
        if (question.answer_resource_id) {
            const resourceId = +question.answer_resource_id;
            if (question.answer_resource_type.toLowerCase() === 'ticket') {
                if (this.props.tickets && (Array.isArray(this.props.tickets.tickets) || Array.isArray(this.props.tickets.bundleTickets))) {
                    let priceLevelId = null;
                    let tickets = this.props.tickets.tickets.length ? this.props.tickets.tickets : this.props.tickets.bundleTickets;
                    tickets.forEach(ticket => {
                        if (+ticket.id === resourceId) {
                            if (ticket.price_level_name && (typeof ticket.price_level_name === 'string' || ticket.price_level_name instanceof String)) {;
                                resourceName = ticket.price_level_name;
                            }
                            priceLevelId = ticket.price_level_id;
                            return false;
                        }
                    });
                    if (resourceName != null) {
                        return resourceName;
                    }
                    if (priceLevelId && this.props.priceLevels && typeof this.props.priceLevels.levels === 'object') {
                        Object.keys(this.props.priceLevels.levels).forEach(levelId => {
                            if (+levelId === +priceLevelId) {
                                resourceName = this.props.priceLevels.levels[levelId].name;
                                return false;
                            }
                        });
                    }
                }
            }
            if (question.answer_resource_type.toLowerCase() === 'bundlesale') {
                if (this.props.bundleSales && Array.isArray(this.props.bundleSales.bundles)) {
                    let bundleId = null;
                    this.props.bundleSales.bundles.forEach(bundleSale => {
                        if (+bundleSale.id === resourceId) {
                            bundleId = bundleSale.bundle_id;
                        }
                    });
                    if (bundleId && this.props.bundles && typeof this.props.bundles.bundles === 'object') {
                        Object.keys(this.props.bundles.bundles).forEach(key => {
                            if (+key === +bundleId) {
                                resourceName = this.props.bundles.bundles[key].name;
                            }
                        });
                    }
                }
            }
        }
        return resourceName;
    }
}

const mapStateToProps = state => {
    return {
        isKioskMode: isKioskMode(state),
    }
}

EventQuestionList.propTypes = {
    eventTitle: PropTypes.string,
    questions: PropTypes.arrayOf(PropTypes.object),
    ticketQuestions: PropTypes.object,
    numEvents: PropTypes.number.isRequired,
    tickets: PropTypes.object,
    priceLevels: PropTypes.object,
    bundles: PropTypes.object,
    bundleSales: PropTypes.object,
}

export default connect(mapStateToProps)(EventQuestionList)
